import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from '../../../services/role.service';
import {TreeviewConfig, TreeviewItem} from '@charmedme/ngx-treeview';
import {DomUtil} from 'leaflet';

@Component({
  selector: 'app-role-edit',
  templateUrl: './role-edit.component.html',
  styleUrls: ['./role-edit.component.scss']
})
export class RoleEditComponent implements OnInit{

  roleForm: FormGroup;

  modules: any[] = [];
  menus: any[] = [];
  permissions: any[] = [];
  roles: any[] = [];

  loadForm = true;

  layout = localStorage.getItem('layout')

  moduleSelected: number | undefined;

  load = false;
  saving = false;

  public data: any;
  id: number;

  isSubmitted = false;

  val: any | null;
  pop: any;

  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;

  config = TreeviewConfig.create({
    hasAllCheckBox: true,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: false,
    maxHeight: 400
  });

  items: TreeviewItem[] = [];

  value: number | undefined;


  constructor(private fb: FormBuilder,
              private roleService: RoleService,
              private translate: TranslateService,
              private toast: ToastrService,
              public router: ActivatedRoute,
              public route: Router
  ) {
    this.roleForm = this.fb.group({
      name: ['', [Validators.required]],
    });

  }

  ngOnInit(): void{
    this.id = this.router.snapshot.params.id;
	this.roleForm.get('isEnable')?.setValue('1');
    this.roleForm.patchValue(this.data);
	this.roleForm.get('isEnable')?.setValue(this.data.isEnable ? '1' : '0');
    this.load = true;
    console.log(this.id);
    console.log(this.data);

    if (this.id){
      const objt: any = {};
      console.log(this.id)

      this.roleService.getCustomList(this.id).subscribe(x => {
        console.log(x);
        this.roles = x['hydra:member'][0].module;

        const roleName = x['hydra:member'][0].name;

        this.roleForm.get('name').setValue(roleName);

        this.load = false;
        // this.roleForm.patchValue(x['hydra:member'][0].name);
        console.log(this.roles);
        //this.roleForm.get('isEnable')?.setValue(x.isEnable ? '1' : '0');



        this.items = this.roles.map((v) => {
          objt.category = v.category;
          objt.text = v.name;
          objt.value = v.id;
          objt.checked = v.status;
          objt.children = v.menus.map((m: any) => {

            if (m.permissions) {
              return {
                text : m.name,
                value : m.id,
                checked: m.status,
                category: m.category,
                children : m.permissions?.map((s: any) => {
                  return {
                    text: s.name,
                    value: s.id,
                    checked: s.status,
                    category: s.category,
                    children: s.permissions?.map((p: any) => {
                      return {
                        text: p.name,
                        value: p.id,
                        checked: p.status,
                        category: p.category,
                      };
                    })
                  };
                })
              };
            }

            if (m.submenu){
              return {
                text : m.name,
                value : m.id,
                checked: m.status,
                category: m.category,
                children : m.submenu?.map((s: any) => {
                  return {
                    text: s.name,
                    value: s.id,
                    checked: s.status,
                    category: s.category,
                    children: s.permissions?.map((p: any) => {
                      return {
                        text: p.name,
                        value: p.id,
                        checked: p.status,
                        category: p.category,
                      };
                    })
                  };
                })
              };
            }


            if (m.category === 'single'){
              return {
                text : m.name,
                value : m.id,
                checked: m.status,
                category: m.category,
                children : m.permissions?.map((p: any) => {
                  return {
                    text: p.name,
                    value: p.id,
                    checked: p.status,
                    category: p.category
                  };
                })
              };
            }

          });
          console.log(objt);
          return new TreeviewItem(objt);

        });

        console.log(this.roles)
        console.log(this.items)

        this.loadForm = false;


      });
    }

  }

  select(item: TreeviewItem): void{
    console.log(item);
    this.value = item.value;
  }

  onSelectedChange(event: number[]): void{
    console.log(event);
  }

  changeVal(value: any): void{
    this.val = value;
    console.log(this.val);
  }

  get fc(): any {
    return this.roleForm.controls;
  }

  onFormSubmit(): any {
    this.isSubmitted = true;
    if (this.roleForm.valid){
      this.saving = true;
      if (this.id){
        console.log(this.id);

        // Assurez-vous que les types de données sont correctement définis
        // interface TreeviewItem {
        //   type: string;
        //   checked: boolean;
        //   text: string;
        //   value: number;
        //   children?: TreeviewItem[];
        // }

        console.log(this.items);

        //Fonction pour adapter la structure en fonction du formulaire
        this.pop = this.items.map((v:any) => {
          return  {
            category: v.category,
            checked: v.checked,
            text: v.text,
            module: v.value,
            children: v.children?.map((m:any) => {
              return  {
                checked: m.checked,
                text: m.text,
                menu: m.value,
                category: m.category,
                children: m.children?.map((s:any) => {
                  if (!s.children) {
                    // Adaptation pour un élément de type permission
                    return {
                      category: s.category,
                      checked: s.checked,
                      text: s.text,
                      permission: s.value,
                    };
                  } else {
                    // Adaptation pour un élément de type submenu
                    return {
                      checked: s.checked,
                      text: s.text,
                      submenu: s.value,
                      category: s.category,
                      children: s.children?.map((p:any) => {
                        // Adaptation pour un élément de type permission
                        return {
                          category: p.category,
                          checked: p.checked,
                          text: p.text,
                          permission: p.value,
                        };
                      }),
                    };


                  }
                }),
              };


            }),
          };


        });

        console.log(this.pop);
        this.roleService.updateRole(this.id, this.pop, this.roleForm.value).subscribe({
          next: (val: any) => {
            this.toast.success(this.translate.instant('profile') + ' ' + this.translate.instant('edited') + ' ' + this.translate.instant('successfully!'), 'Success');
            // this.activeModal.close();
            this.route.navigate(['/security/role']);
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            this.saving = false;
            console.log(err);
            const errors: any[] = err.error.violations;

            if (errors){
              errors.forEach((v) => {
                if (v.propertyPath === 'name') {
                  this.roleForm.get('name')?.setErrors({serverError: v.message});
                }
                // window.scrollTo({ top: 0, behavior: 'smooth'});
                this.saving = false;
              });
            }
            else {
              // window.scrollTo({ top: 0, behavior: 'smooth'});
              this.toast.error(err['hydra:title'], 'Error');
              this.saving = false;
            }

          }
        });
      }

    }
  }

}
